import { queryOptions, useQuery } from '@tanstack/react-query';
import { ActivityService } from '../../generated';
import { blobToDataURL } from '../../common';
import { ApiError } from '../../../components/ApiLoadingGuard/ApiLoadingGuard';
import { STALE_TIME_LIVE_VIEW } from '../../queryClient';

export const activityImageKeys = {
  base: () => ['activityImage'] as const,
  one: ({ jobsiteId, captureStartAt }: ActivityImageOptionProps) =>
    [...activityImageKeys.base(), jobsiteId, captureStartAt] as const,
};

export interface ActivityImageOptionProps {
  jobsiteId: string;
  captureStartAt: string;
}

export function activityImageOptions({
  jobsiteId,
  captureStartAt,
  enabled,
}: ActivityImageOptionProps & { enabled: boolean }) {
  return queryOptions<string, ApiError>({
    queryKey: activityImageKeys.one({ jobsiteId, captureStartAt }),
    queryFn: async () => {
      if (!jobsiteId || !captureStartAt) {
        throw new Error('jobsiteId and captureStartAt are required');
      }

      const response = await ActivityService.activityControllerGetActivityImage({
        path: {
          jobsiteId,
          capture_start_at: captureStartAt,
        },
      });

      if (response.data !== undefined) {
        return await blobToDataURL(response.data as Blob);
      } else {
        throw (response as any).error || new Error(response?.response?.statusText || 'Unknown error');
      }
    },
    enabled: !!jobsiteId && !!captureStartAt && enabled,
    staleTime: STALE_TIME_LIVE_VIEW,
  });
}

export function useActivityImage(props: ActivityImageOptionProps & { enabled: boolean }) {
  return useQuery(activityImageOptions(props));
}
